// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Read the Docs promotional block, only applicable to RTD.org

To support sphinx_rtd_theme, a \`wy-menu\` element is added. Other themes are
targeted using the theme identifier and use custom elements instead of a CSS
framework html structure.

*/

div.ethical-sidebar,
div.ethical-footer {
  display: block !important;
}
.ethical-sidebar,
.ethical-footer {
  padding: 0.5em;
  margin: 1em 0;
}
.ethical-sidebar img,
.ethical-footer img {
  width: 120px;
  height: 90px;
  display: inline-block;
}
.ethical-sidebar .ethical-callout,
.ethical-footer .ethical-callout {
  padding-top: 1em;
  clear: both;
}
.ethical-sidebar .ethical-pixel,
.ethical-footer .ethical-pixel,
.ethical-fixedfooter .ethical-pixel {
  display: none !important;
}
.ethical-sidebar .ethical-text,
.ethical-footer .ethical-text {
  margin-top: 1em;
}
.ethical-sidebar .ethical-image-link,
.ethical-footer .ethical-image-link {
  border: 0;
}

.ethical-sidebar .ea-cta,
.ethical-footer .ea-cta {
  display: block;
  border: 1px solid #ccc;
  border-radius: 0.5em;
  margin-top: 0.5em;
  margin-left: 1em;
  margin-right: 1em;
}

.ethical-sidebar,
.ethical-footer {
  background-color: #eee;
  border: 1px solid #ccc;
  border-radius: 5px;
  color: #0a0a0a;
  font-size: 14px;
  line-height: 20px;
}

/* Techstack badging */
.ethical-sidebar ul {
  margin: 0 !important;
  padding-left: 0;
  list-style: none;
}
.ethical-sidebar ul li {
  display: inline-block;
  background-color: lightskyblue;
  color: black;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: 700;
  margin: 0.25em;
  border-radius: 0.25rem;
  text-align: center;
  vertical-align: baseline;
  white-space: nowrap;
  line-height: 1.41;
}
.ethical-sidebar ul li:not(:last-child) {
  margin-right: 0.25rem;
}

.ethical-sidebar a,
.ethical-sidebar a:visited,
.ethical-sidebar a:hover,
.ethical-sidebar a:active,
.ethical-footer a,
.ethical-footer a:visited,
.ethical-footer a:hover,
.ethical-footer a:active {
  color: #0a0a0a;
  text-decoration: none !important;
  border-bottom: 0 !important;
}

.ethical-callout a {
  color: #707070 !important;
  text-decoration: none !important;
}

/* Sidebar promotions */
.ethical-sidebar {
  text-align: center;
  max-width: 300px;
  margin-left: auto;
  margin-right: auto;
}

/* Footer promotions */
.ethical-footer {
  text-align: left;

  font-size: 14px;
  line-height: 20px;
}
.ethical-footer img {
  float: right;
  margin-left: 25px;
}
.ethical-footer .ethical-callout {
  text-align: center;
}
.ethical-footer small {
  font-size: 10px;
}

/* Fixed footer promotions */
.ethical-fixedfooter {
  box-sizing: border-box;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 100;
  background-color: #eee;
  border-top: 1px solid #bfbfbf;
  font-size: 12px;
  line-height: 1.5;
  padding: 0.5em 1.5em;
  text-align: center;
  color: #404040;
  width: 100%; /* Fallback for Opera Mini */
  width: 100vw;
}
@media (min-width: 769px) {
  /* Improve viewing on non-mobile */
  .ethical-fixedfooter {
    font-size: 13px;
    padding: 1em 1.5em;
  }
}
.ethical-fixedfooter .ethical-text:before {
  margin-right: 4px;
  padding: 2px 6px;
  border-radius: 3px;
  background-color: #4caf50;
  color: #fff;
  content: "Sponsored";
}
.ethical-fixedfooter .ethical-callout {
  color: #999;
  padding-left: 6px;
  white-space: nowrap;
}
.ethical-fixedfooter a,
.ethical-fixedfooter a:hover,
.ethical-fixedfooter a:active,
.ethical-fixedfooter a:visited {
  color: #404040;
  text-decoration: none;
}
.ethical-fixedfooter .ethical-close {
  position: absolute;
  top: 0;
  right: 5px;
  font-size: 20px;
  line-height: 20px;
}

/* RTD Theme specific customizations */
.wy-nav-side .ethical-rtd {
  /* RTD theme doesn't correctly set the sidebar width */
  max-width: 300px;
  padding: 0 1em;
}
.ethical-rtd .ethical-sidebar {
  /* RTD theme doesn't set sidebar text color */
  color: #b3b3b3;

  font-size: 14px;
  line-height: 20px;
}

@media (min-width: 769px) {
  /* Make sure the fixed footer ad is under the RTD theme version selector */
  .wy-body-for-nav .ethical-fixedfooter {
    padding-left: 300px;
  }
}

/* Light theme customizations for non-Alabaster themes */
.ethical-light-theme hr {
  /* Add spacing before the footer ad */
  margin-top: 2em;
}
.ethical-light-theme::before {
  /* Clear floating elements above the ad */
  clear: both;
  content: "";
  display: table;
  margin-top: 3em;
}

/* Alabaster specific customizations */
.ethical-alabaster a.ethical-image-link {
  /* Alabaster adds a border even to image links on hover */
  border: 0 !important;
}
.ethical-alabaster hr {
  /* Alabaster needs some extra spacing before the footer ad */
  margin-top: 2em;
}
.ethical-alabaster::before {
  /* Alabaster's search box above the ad is floating */
  clear: both;
  content: "";
  display: table;
  margin-top: 3em;
}

/* Dark theme */
.ethical-dark-theme .ethical-sidebar {
  background-color: #4e4b4b;
  border: 1px solid #a0a0a0;
  color: #c2c2c2 !important;
}
.ethical-dark-theme a,
.ethical-dark-theme a:visited {
  color: #e6e6e6 !important;
  border-bottom: 0 !important;
}
.ethical-dark-theme .ethical-callout a {
  color: #b3b3b3 !important;
}
.ethical-dark-theme .ethical-sidebar .ea-cta,
.ethical-dark-theme .ethical-footer .ea-cta {
  border-color: #a0a0a0;
}

/* Docusaurus */
.ethical-docusaurus {
  margin-left: 10% !important;
  margin-right: 10% !important;
}

/* Docsify */
.ethical-docsify {
  margin-left: 10% !important;
  margin-right: 10% !important;
}
`, "",{"version":3,"sources":["webpack://./src/ethicalads.css"],"names":[],"mappings":"AAAA;;;;;;CAMC;;AAED;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,cAAc;EACd,aAAa;AACf;AACA;;EAEE,YAAY;EACZ,YAAY;EACZ,qBAAqB;AACvB;AACA;;EAEE,gBAAgB;EAChB,WAAW;AACb;AACA;;;EAGE,wBAAwB;AAC1B;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,SAAS;AACX;;AAEA;;EAEE,cAAc;EACd,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,YAAY;EACZ,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,qBAAqB;AACvB;;AAEA;;;;;;;;EAQE,cAAc;EACd,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;;EAEhB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,sBAAsB;EACtB,eAAe;EACf,SAAS;EACT,OAAO;EACP,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,WAAW,EAAE,4BAA4B;EACzC,YAAY;AACd;AACA;EACE,kCAAkC;EAClC;IACE,eAAe;IACf,kBAAkB;EACpB;AACF;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;AACA;;;;EAIE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,eAAe;EACf,iBAAiB;AACnB;;AAEA,sCAAsC;AACtC;EACE,sDAAsD;EACtD,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,6CAA6C;EAC7C,cAAc;;EAEd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,0EAA0E;EAC1E;IACE,mBAAmB;EACrB;AACF;;AAEA,wDAAwD;AACxD;EACE,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,yCAAyC;EACzC,WAAW;EACX,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA,sCAAsC;AACtC;EACE,yDAAyD;EACzD,oBAAoB;AACtB;AACA;EACE,4DAA4D;EAC5D,eAAe;AACjB;AACA;EACE,oDAAoD;EACpD,WAAW;EACX,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,YAAY;AACZ;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B","sourcesContent":["/* Read the Docs promotional block, only applicable to RTD.org\n\nTo support sphinx_rtd_theme, a `wy-menu` element is added. Other themes are\ntargeted using the theme identifier and use custom elements instead of a CSS\nframework html structure.\n\n*/\n\ndiv.ethical-sidebar,\ndiv.ethical-footer {\n  display: block !important;\n}\n.ethical-sidebar,\n.ethical-footer {\n  padding: 0.5em;\n  margin: 1em 0;\n}\n.ethical-sidebar img,\n.ethical-footer img {\n  width: 120px;\n  height: 90px;\n  display: inline-block;\n}\n.ethical-sidebar .ethical-callout,\n.ethical-footer .ethical-callout {\n  padding-top: 1em;\n  clear: both;\n}\n.ethical-sidebar .ethical-pixel,\n.ethical-footer .ethical-pixel,\n.ethical-fixedfooter .ethical-pixel {\n  display: none !important;\n}\n.ethical-sidebar .ethical-text,\n.ethical-footer .ethical-text {\n  margin-top: 1em;\n}\n.ethical-sidebar .ethical-image-link,\n.ethical-footer .ethical-image-link {\n  border: 0;\n}\n\n.ethical-sidebar .ea-cta,\n.ethical-footer .ea-cta {\n  display: block;\n  border: 1px solid #ccc;\n  border-radius: 0.5em;\n  margin-top: 0.5em;\n  margin-left: 1em;\n  margin-right: 1em;\n}\n\n.ethical-sidebar,\n.ethical-footer {\n  background-color: #eee;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  color: #0a0a0a;\n  font-size: 14px;\n  line-height: 20px;\n}\n\n/* Techstack badging */\n.ethical-sidebar ul {\n  margin: 0 !important;\n  padding-left: 0;\n  list-style: none;\n}\n.ethical-sidebar ul li {\n  display: inline-block;\n  background-color: lightskyblue;\n  color: black;\n  padding: 0.25em 0.4em;\n  font-size: 75%;\n  font-weight: 700;\n  margin: 0.25em;\n  border-radius: 0.25rem;\n  text-align: center;\n  vertical-align: baseline;\n  white-space: nowrap;\n  line-height: 1.41;\n}\n.ethical-sidebar ul li:not(:last-child) {\n  margin-right: 0.25rem;\n}\n\n.ethical-sidebar a,\n.ethical-sidebar a:visited,\n.ethical-sidebar a:hover,\n.ethical-sidebar a:active,\n.ethical-footer a,\n.ethical-footer a:visited,\n.ethical-footer a:hover,\n.ethical-footer a:active {\n  color: #0a0a0a;\n  text-decoration: none !important;\n  border-bottom: 0 !important;\n}\n\n.ethical-callout a {\n  color: #707070 !important;\n  text-decoration: none !important;\n}\n\n/* Sidebar promotions */\n.ethical-sidebar {\n  text-align: center;\n  max-width: 300px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n/* Footer promotions */\n.ethical-footer {\n  text-align: left;\n\n  font-size: 14px;\n  line-height: 20px;\n}\n.ethical-footer img {\n  float: right;\n  margin-left: 25px;\n}\n.ethical-footer .ethical-callout {\n  text-align: center;\n}\n.ethical-footer small {\n  font-size: 10px;\n}\n\n/* Fixed footer promotions */\n.ethical-fixedfooter {\n  box-sizing: border-box;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  z-index: 100;\n  background-color: #eee;\n  border-top: 1px solid #bfbfbf;\n  font-size: 12px;\n  line-height: 1.5;\n  padding: 0.5em 1.5em;\n  text-align: center;\n  color: #404040;\n  width: 100%; /* Fallback for Opera Mini */\n  width: 100vw;\n}\n@media (min-width: 769px) {\n  /* Improve viewing on non-mobile */\n  .ethical-fixedfooter {\n    font-size: 13px;\n    padding: 1em 1.5em;\n  }\n}\n.ethical-fixedfooter .ethical-text:before {\n  margin-right: 4px;\n  padding: 2px 6px;\n  border-radius: 3px;\n  background-color: #4caf50;\n  color: #fff;\n  content: \"Sponsored\";\n}\n.ethical-fixedfooter .ethical-callout {\n  color: #999;\n  padding-left: 6px;\n  white-space: nowrap;\n}\n.ethical-fixedfooter a,\n.ethical-fixedfooter a:hover,\n.ethical-fixedfooter a:active,\n.ethical-fixedfooter a:visited {\n  color: #404040;\n  text-decoration: none;\n}\n.ethical-fixedfooter .ethical-close {\n  position: absolute;\n  top: 0;\n  right: 5px;\n  font-size: 20px;\n  line-height: 20px;\n}\n\n/* RTD Theme specific customizations */\n.wy-nav-side .ethical-rtd {\n  /* RTD theme doesn't correctly set the sidebar width */\n  max-width: 300px;\n  padding: 0 1em;\n}\n.ethical-rtd .ethical-sidebar {\n  /* RTD theme doesn't set sidebar text color */\n  color: #b3b3b3;\n\n  font-size: 14px;\n  line-height: 20px;\n}\n\n@media (min-width: 769px) {\n  /* Make sure the fixed footer ad is under the RTD theme version selector */\n  .wy-body-for-nav .ethical-fixedfooter {\n    padding-left: 300px;\n  }\n}\n\n/* Light theme customizations for non-Alabaster themes */\n.ethical-light-theme hr {\n  /* Add spacing before the footer ad */\n  margin-top: 2em;\n}\n.ethical-light-theme::before {\n  /* Clear floating elements above the ad */\n  clear: both;\n  content: \"\";\n  display: table;\n  margin-top: 3em;\n}\n\n/* Alabaster specific customizations */\n.ethical-alabaster a.ethical-image-link {\n  /* Alabaster adds a border even to image links on hover */\n  border: 0 !important;\n}\n.ethical-alabaster hr {\n  /* Alabaster needs some extra spacing before the footer ad */\n  margin-top: 2em;\n}\n.ethical-alabaster::before {\n  /* Alabaster's search box above the ad is floating */\n  clear: both;\n  content: \"\";\n  display: table;\n  margin-top: 3em;\n}\n\n/* Dark theme */\n.ethical-dark-theme .ethical-sidebar {\n  background-color: #4e4b4b;\n  border: 1px solid #a0a0a0;\n  color: #c2c2c2 !important;\n}\n.ethical-dark-theme a,\n.ethical-dark-theme a:visited {\n  color: #e6e6e6 !important;\n  border-bottom: 0 !important;\n}\n.ethical-dark-theme .ethical-callout a {\n  color: #b3b3b3 !important;\n}\n.ethical-dark-theme .ethical-sidebar .ea-cta,\n.ethical-dark-theme .ethical-footer .ea-cta {\n  border-color: #a0a0a0;\n}\n\n/* Docusaurus */\n.ethical-docusaurus {\n  margin-left: 10% !important;\n  margin-right: 10% !important;\n}\n\n/* Docsify */\n.ethical-docsify {\n  margin-left: 10% !important;\n  margin-right: 10% !important;\n}\n"],"sourceRoot":""}]);
// Exports
var ___CSS_LOADER_STYLE_SHEET___ = new CSSStyleSheet();
___CSS_LOADER_STYLE_SHEET___.replaceSync(___CSS_LOADER_EXPORT___.toString());
export default ___CSS_LOADER_STYLE_SHEET___;
